import { Data } from "effect";
import type { ValidationErrorData } from "./DomainError";

/**
 * General validation error for schema or data validation failures
 */
export class ValidationError extends Data.TaggedError("@/ValidationError")<ValidationErrorData> {}

/**
 * Error thrown when required data is missing
 */
export class MissingDataError extends Data.TaggedError("@/MissingDataError")<
  ValidationErrorData & {
    readonly missingFields: string[];
  }
> {}

/**
 * Error thrown when data format is invalid
 */
export class InvalidFormatError extends Data.TaggedError("@/InvalidFormatError")<
  ValidationErrorData & {
    readonly expectedFormat: string;
    readonly actualFormat: string;
  }
> {}

/**
 * Error thrown when data is outside acceptable range
 */
export class OutOfRangeError extends Data.TaggedError("@/OutOfRangeError")<
  ValidationErrorData & {
    readonly minValue?: number;
    readonly maxValue?: number;
    readonly actualValue: number;
  }
> {}

/**
 * Error thrown when string length constraints are violated
 */
export class InvalidLengthError extends Data.TaggedError("@/InvalidLengthError")<
  ValidationErrorData & {
    readonly minLength?: number;
    readonly maxLength?: number;
    readonly actualLength: number;
  }
> {}

/**
 * Error thrown when enum value is not recognized
 */
export class InvalidEnumValueError extends Data.TaggedError("@/InvalidEnumValueError")<
  ValidationErrorData & {
    readonly allowedValues: string[];
    readonly providedValue: string;
  }
> {}

/**
 * Error thrown when schema validation fails
 */
export class SchemaValidationError extends Data.TaggedError("@/SchemaValidationError")<
  ValidationErrorData & {
    readonly schemaName: string;
    readonly validationErrors: string[];
  }
> {}
